import AppSettings from '../../../AppSettings';
// Librairies
import i18n from '../../../locales/i18n';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

export const photoHandlers = {
    'photo.upload': {
        describe: () => i18n.t("Ajout d'une photo"),
        // Mêmes champs que Tasks.uploadPhoto ; délai proportionnel à la taille (60 s + 30 ms par Ko)
        buildRequest: async (op, context) => {
            const photo = await context.photos.get(op.target.id);
            if (!photo) return { discard: true, reason: 'photo_missing' };
            // Occurrence créée sur l'appareil (id négatif) : id serveur connu une fois l'occurrence acceptée
            const recurrenceId = photo.recurrenceId ? await context.idMap.resolve('occurrence', photo.recurrenceId) : null;
            const formData = new FormData();
            formData.append('type', 'photo');
            formData.append('id', photo.id);
            formData.append('projectId', photo.projectId);
            formData.append('elementId', photo.elementId);
            formData.append('category', photo.category);
            formData.append('recurrenceId', recurrenceId ?? null);
            formData.append('blobName', photo.blobName);
            formData.append('createdAt', photo.createdAt);
            formData.append('file', photo.file, photo.blobName);
            return { request: { method: 'post', url: `${BACKEND_ENDPOINT}fileInfos/`, data: formData, headers: { 'content-type': 'multipart/form-data' }, timeout: 60000 + Math.round((photo.file?.size || 0) / 1024) * 30 } };
        },
        onSuccess: async (op, response, context) => {
            await context.idMap.set('fileInfo', op.target.id, response.data.id);
            await context.photos.remove(op.target.id);
            return { fileInfo: response.data, localId: op.target.id };
        },
        onAbandon: (op, context) => context.photos.remove(op.target.id)
    },
    // Photos prises sur l'appareil : id serveur connu une fois leur envoi accepté (elles passent avant dans la file)
    'photo.delete': {
        describe: op => i18n.t("Suppression de photos ({{count}})", { count: op.payload.ids.length }),
        buildRequest: async (op, context) => {
            const ids = [];
            for (const id of op.payload.ids) ids.push(await context.idMap.resolve('fileInfo', id));
            return { request: { method: 'delete', url: `${BACKEND_ENDPOINT}fileInfos/`, data: { ids: ids.filter(id => id !== undefined) } } };
        },
        onSuccess: async () => ({}),
        // Photos déjà supprimées ailleurs (ou avec leur élément, envoyé par l'autre voie)
        isAlreadyDone: (error) => error?.response?.status === 404
    },
    'photo.setPreview': {
        describe: () => i18n.t("Choix de la photo principale"),
        buildRequest: async (op) => ({ request: { method: 'put', url: `${BACKEND_ENDPOINT}fileInfos/photoPreview/`, data: op.payload } }),
        onSuccess: async () => ({})
    },
    'photo.update': {
        describe: () => i18n.t("Renommage d'une photo"),
        buildRequest: async (op, context) => {
            const id = await context.idMap.resolve('fileInfo', op.target.id);
            return { request: { method: 'put', url: `${BACKEND_ENDPOINT}fileInfos/${id}`, data: { ...op.payload.fileInfo, id } } };
        },
        onSuccess: async (op, response) => ({ fileInfo: response.data }),
        isAlreadyDone: (error) => error?.response?.status === 404
    }
};
